import { Event } from "../../../../Global/Base/Events";
import { CultureInfo } from "../../../../Global/Dom/CultureInfo";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { Control } from "./Control";
import { ControlParams } from "./ControlInterfaces";
import { IHasCulture } from "./ControlInterfacesStrict";
import { EditableControl } from "./EditableControl";

/** Control that depends on culture. */
export class CultureDependentEditableControl extends EditableControl implements IHasCulture {
    protected _culture: string;
    public cultureChanged: Event<Control, string> = new Event<Control, string>();

    constructor(params: ControlParams) {
        super(params);
        this._events.add(Localization.languageChanged, (_, data) => this.culture = data.culture);
    }

    /** Get culture code. */
    public get culture(): string {
        if (!this._culture) {
            this._culture = CultureInfo.getCulture();
        }
        return this._culture;
    }

    /** Sets culture code. */
    public set culture(value: string) {
        this._culture = value;
        this.cultureChanged.trigger(this, value);
    }
}
